import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';

class GalleryPreviewGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      links: [],
      loading: true,
      error: null,
    };
  }

  componentDidMount() {
    fetch(`${process.env.REACT_APP_API_URL}/api/globals/home-gallery-links?depth=2`)
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP error ${res.status}`);
        return res.json();
      })
      .then((data) => {
        this.setState({ links: data.links || [], loading: false });
      })
      .catch((err) => {
        console.error('Gallery links fetch error:', err);
        this.setState({ error: err.message, loading: false });
      });
  }

  render() {
    const { links, loading, error } = this.state;

    if (loading) return <p>Loading galleries...</p>;
    if (error) return <p>Error: {error}</p>;
    if (!links.length) return null;

    return (
      <Container className="my-5">
        <Row>
          {links.map((link, index) => {
            const gallery = link.gallery;
            if (!gallery) return null;

            // Use the explicitly chosen cover image, else fall back to the
            // gallery's first image.
            const coverImage =
              link.image ||
              (gallery.images?.[0]?.image) ||
              null;

            const imageUrl = coverImage?.url || null;
            const label = link.label || gallery.name;
            const slug = gallery.slug;

            if (!slug) return null;

            return (
              <Col key={link.id || index} lg={3} md={4} sm={6} xs={12} className="mb-4">
                <a
                  href={`/gallery/${slug}`}
                  style={{ textDecoration: 'none', color: 'inherit' }}
                >
                  <div style={{ textAlign: 'center' }}>
                    <div
                      style={{
                        width: '100%',
                        height: '300px',
                        overflow: 'hidden',
                        backgroundColor: '#f8f9fa',
                      }}
                    >
                      {imageUrl ? (
                        <img
                          src={imageUrl}
                          alt={coverImage?.altText || label}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                          }}
                        />
                      ) : (
                        <div
                          style={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#aaa',
                            fontSize: '14px',
                          }}
                        >
                          No image
                        </div>
                      )}
                    </div>
                    <h5 className="mt-2">{label}</h5>
                  </div>
                </a>
              </Col>
            );
          })}
        </Row>
      </Container>
    );
  }
}

export default GalleryPreviewGrid;
